var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.998,
    height: 13.435,
    viewBox: "0 0 20.998 13.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_42",
    "data-name": "Union 42",
    d: "M1.806,13.435A1.8,1.8,0,0,1,0,11.644V1.792A1.8,1.8,0,0,1,1.806,0H15.053a1.8,1.8,0,0,1,1.805,1.792v1.46l2.535-2.1A.978.978,0,0,1,21,1.9v9.63a.978.978,0,0,1-.981.972.967.967,0,0,1-.622-.226l-2.536-2.1v1.461a1.8,1.8,0,0,1-1.805,1.791ZM1.128,1.792v9.852a.675.675,0,0,0,.679.67H15.053a.675.675,0,0,0,.678-.67V1.792a.676.676,0,0,0-.678-.671H1.806A.676.676,0,0,0,1.128,1.792ZM16.859,4.71V8.726l3.011,2.489V2.221Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video-on.5887f12ae77e466181e8a66bf079ab15.svg";
export { ForwardRef as ReactComponent };